import { Box, styled } from '@mui/material';

// Styled container to hold groups of FormFields in a responsive grid
export const FormFieldGroupContainer = styled(Box)({
  display: 'grid',
  columnGap: '20px',
  rowGap: '5px',
  gridTemplateColumns: 'repeat(2, 1fr)',
  margin: '10px 0px',
});
